import React from 'react';
import { Typography } from 'antd';
import MetadataList from '../components/MetadataList';

const { Title } = Typography;

const MetadataPage = () => {
  return (
    <div style={{ ...styles.container, paddingTop: '84px' }}>
      <div style={styles.header}>
        <Title style={styles.title}>Glossary</Title>
        <p style={styles.subtitle}>
          Explore all available metrics and their detailed descriptions and formulas.
        </p>
        <p style={styles.hint}>
          Tip: Click on a card to freeze the back side for easier reading.
        </p>
      </div>
      <div style={styles.content}>
        <MetadataList /> {/* Render the MetadataList component */}
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: 'white',
    padding: '20px',
    boxSizing: 'border-box', // Ensures padding is included in size calculation
  },
  header: {
    textAlign: 'center',
    marginBottom: '20px',
  },
  title: {
    fontSize: '50px',
    background: 'linear-gradient(135deg, #1890ff 0%, #722ed1 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    margin: 0, // Remove default margin
  },
  subtitle: {
    fontSize: '18px',
    color: '#555',
    margin: '10px 0', // Ensure consistent spacing
  },
  hint: {
    fontSize: '14px',
    color: '#888',
    fontStyle: 'italic',
    margin: '5px 0', // Subtle spacing for the hint text
  },
  content: {
    width: '100%',
    maxWidth: '1200px',
  },
};

export default MetadataPage;
